import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useMemo } from "react";
import { useConfig } from "../../contexts/config-context.js";
import { DatePickerWUT } from "../date-picker/date-picker-wut.js";
import { parseDateTimeValue, formatDateTimeValue } from "./date-time-field-utils.js";
import styles from "./date-time-field.module.scss";
import { classes } from "./date-time-field.st.css";
import { Fieldset } from "../fieldset/fieldset.js";
import { TimePickerWUT } from "../time-picker/time-picker-wut.js";
function DateTimeFieldWUT({
  use24HourFormat = false,
  onBlur,
  onChange,
  onFocus,
  inputId,
  ariaLabelledBy,
  value,
  id,
  disabled,
  errors,
  hidePlaceholder,
  showDateLabels,
  required,
  ariaDescribedBy
}) {
  const { isMobile } = useConfig();
  const [date, time] = useMemo(() => parseDateTimeValue(value), [value]);
  return /* @__PURE__ */ jsxs(
    Fieldset,
    {
      id: inputId,
      onFocus,
      onBlur,
      ariaLabelledBy,
      className: classNames(styles.fields, classes.gap, {
        [styles.mobile]: isMobile
      }),
      ariaDescribedBy,
      required,
      children: [
        /* @__PURE__ */ jsx(
          DatePickerWUT,
          {
            disabled,
            errors,
            hidePlaceholder,
            showDateLabels,
            required,
            inputId,
            id,
            onChange: (newDate) => onChange(formatDateTimeValue(newDate, time)),
            value: date
          }
        ),
        /* @__PURE__ */ jsx(
          TimePickerWUT,
          {
            inputId,
            disabled,
            readOnly: false,
            error: errors.TIME,
            hidePlaceholder,
            showTimeLabel: showDateLabels,
            required,
            className: styles.time,
            "data-hook": `${id}-time`,
            use24Hours: use24HourFormat,
            onChange: (newTime) => onChange(formatDateTimeValue(date, newTime)),
            value: time
          }
        )
      ]
    }
  );
}
export {
  DateTimeFieldWUT
};
//# sourceMappingURL=date-time-field-wut.js.map
